<template>
    <td-dialog :title="title" append-to-body="true" width="330px" :before-close="dialogClose" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formInfo" ref="formInfo" label-position="right" :label-width="formLabelWidth" :rules="rules">
            <!-- <el-form-item :label="$t('pgCommon.PERSON_NAME')" prop="sNumber">
                <td-input v-model="formInfo.staffName" :disabled="sNumberDisabled" maxlength="50" readonly="readonly"></td-input>
            </el-form-item> -->
            <el-form-item :label="$t('pgCommon.POST_STATION')" prop="sNumber">
                <td-select
                    :url="url"
                    ref="select"
                    keys="sId"
                    text="sName"
                    :urlParam="requetParam"
                    requestType="POST"
                    :isPage="true"
                    :placeholder="'common.PLEASE_SELECT'"
                    v-model="formInfo.stationId"
                    @change="portStationChange"
                ></td-select>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.DIRECT_LEADER')" prop="sName">
                <td-org-structure-tree :editItem="editItem" ref="structureTree" @clickChosen="clickChosen" @handleClose="handleClose"></td-org-structure-tree>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm()" :loading="loading">{{ $t('pgCommon.SURE') }}</td-button>
            <td-button type="button" @click.native="dialogClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import staffApi from './../assets/api.js';
export default {
    props: ['title', 'dialogVisible', 'editItem', 'structureItem'],
    created() {},
    // 定义变量
    data() {
        return {
            formInfo: {
                sId: '',
                staffId: '',
                staffName: '',
                stationId: '',
                sDuty: '',
                leaderId: ''
            },
            requetParam: {
                structureIdList: [this.structureItem.id]
            },
            url: '/portStationManagerController/queryPortStationByStructureId',
            formLabelWidth: '80px',
            loading: false,
            sNumberDisabled: false
        };
    },

    // 定义并实现方法体
    methods: {
        portStationChange(data) {
            this.formInfo.stationId = data;
        },
        clickChosen(data) {
            this.formInfo.leaderId = data.staffId;
        },
        handleClose(data) {
            this.formInfo.leaderId = '';
        },
        // 提交数据
        submitForm() {
            if (this.$util.isEmpty(this.formInfo.leaderId) && this.$util.isEmpty(this.formInfo.stationId)) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_BE_BOTH_NULL'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('pgCommon.BATCH_UPDATE_INFO_TIPS'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            }).then(() => {
                this.loading = true;
                let param = {
                    sDeptId: this.structureItem.id
                };
                if (this.formInfo.stationId) {
                    param.sDuty = this.formInfo.stationId;
                } else {
                    param.sDuty = '';
                }
                param.sLeader = this.formInfo.leaderId;
                this.loading = false;
                staffApi.batchSetStaffRelationInfo(JSON.stringify(param), response => {
                    this.addLoading = false;
                    if (response === null || response.status !== this.$common.login.RESPONSE_STATUS) {
                        this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                        this.$log.error('staffApi.batchSetStaffRelationInfo', response);
                        this.loading = false;
                        return;
                    }
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('staffApi.batchSetStaffRelationInfo', response);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('pgCommon.OPERA_SUCCESS'), type: 'success' });
                    this.dialogClose();
                    this.$emit('queryList');
                });
            });
        },
        // 关闭窗口之前需要调用的方法
        dialogClose() {
            this.$emit('dialogClose');
        }
    }
};
</script>
<style scoped>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.calssRuleTitle {
    height: 30px;
    width: 482px;
    background-color: #e8e8e8;
    padding-left: 10px;
    color: #686868;
    display: table-cell;
    vertical-align: middle;
}
.classRuleContent {
    border: 1px solid #e8e8e8;
    width: 480px;
    padding-left: 10px;
    padding-bottom: 10px;
}
</style>
